export const personalInfo = {
  name: "Dharshith Dev KP",
  title: "Full Stack Developer & AI Engineer",
  tagline: "I architect scalable backends, build intelligent AI systems, and ship production-grade web platforms.",
  email: "dharshithdevkp@gmail.com",
  phone: "9037200857",
  location: "Bangalore, Karnataka",
  github: "https://github.com/dharshithdev",
  linkedin: "https://www.linkedin.com/in/dharshithdev",
  photo: "https://res.cloudinary.com/dmnxxqmb4/image/upload/v1778307720/portfolio_image_sa4yyu.jpg",
  resumeUrl: "Dharshith_Dev_Software_Developer.pdf",
};

export const skills = [
  {
    category: "Languages",
    icon: "Code2",
    color: "#00f5ff",
    items: ["JavaScript", "Python", "PHP", "Java", "C++", "C", "SQL", ".NET"],
  },
  {
    category: "Frameworks",
    icon: "Layers",
    color: "#7c3aed",
    items: ["React.js", "Next.js", "Node.js", "Express.js", "FastAPI", "Laravel", "Tailwind CSS", "Framer Motion"],
  },
  {
    category: "Databases & DevOps",
    icon: "Database",
    color: "#10b981",
    items: ["MongoDB", "MySQL", "Mongoose", "Prisma", "Docker", "Git", "Linux", "Postman", "JWT Auth"],
  },
  {
    category: "AI / ML",
    icon: "Brain",
    color: "#f59e0b",
    items: ["LangChain", "RAG", "NLP", "Computer Vision", "Scikit-learn", "NumPy", "Pandas", "YOLOv8", "Vector Search", "OpenAI API"],
  },
];

export const projects = [
  {
    id: 1,
    title: "AI Knowledge Assistant",
    subtitle: "RAG-Powered Document Intelligence",
    period: "April 2025",
    stack: ["MERN", "LangChain", "MongoDB Vector", "OpenAI", "Python"],
    color: "#00f5ff",
    description: "Enterprise-grade Retrieval-Augmented Generation (RAG) orchestration engine built to enable high-fidelity natural language queries and semantic knowledge synthesis over isolated multi-tenant document repositories.",
    highlights: [
     "Engineered an automated ingestion pipeline utilizing LangChain, recursive character text splitting, and dense vector embeddings to maximize contextual relevance and boost query precision by 35%.",
     "Optimized inference compute overhead to achieve a 20% reduction in LLM token consumption by executing deterministic token-chunk strategies and strict cross-reference metadata filtering layers.",
     "Constructed an asynchronous document indexing worker cluster with multi-turn conversational memory, enabling secure, real-time data uploads and context-aware context injections under high concurrency."
    ],
    github: "https://github.com/dharshithdev", 
    live: "https://ai-knowledge-assistant-nine.vercel.app/",
    tag: "AI / ML",
  },
  {
    id: 2,
    title: "AI Code Intelligence",
    subtitle: "ML-Powered Software Defect Prediction",
    period: "August 2026",
    stack: ["Python", "Machine Learning", "Flask", "Tree-sitter", "React", "Vite", "Tailwind CSS"],
    color: "#7c3aed",
    description: "Machine Learning-powered static code intelligence platform that transforms low-level C++ source code into structural software metrics and uses learned patterns to estimate defect probability, combining program analysis, feature engineering, and predictive modeling into an end-to-end AI system.",
    highlights: [
        "Engineered a source-code analysis pipeline using Tree-sitter to parse C++ syntax and extract structural and complexity-oriented features for downstream machine learning inference.",
        "Designed a feature-driven defect prediction pipeline that converts software metrics such as complexity, coupling, nesting depth, code size, loops, and comparisons into predictive signals for classifying potentially defective code.",
        "Integrated the trained ML model into a Flask inference API and built an interactive React interface that visualizes defect probability, prediction results, and derived code-health indicators in real time."
    ],
    github: "https://github.com/dharshithdev/AI-Code-Intelligence.git",
    live: "https://ai-code-intelligence.vercel.app/",
    tag: "AI / ML",
  },
    {
    id: 3,
    title: "Custom Multi-threaded HTTP Server in C++",
    subtitle: "Backend HTTP server in C++",
    period: "May 2026",
    stack: ["C++", "Multithreading", "Socket Programming", "HTTP", "REST APIs"],
    color: "#dc2626",
    description: "High-performance, bare-metal HTTP server engine engineered in C++ leveraging low-level asynchronous network programming and multi-threaded connection pools to optimize throughput for high-concurrency request execution.",
    highlights: [
      "Architected an asynchronous client-server communication mesh utilizing native socket programming (Winsock) and worker thread pooling to isolate execution blocks and minimize connection management overhead.",
      "Engineered a zero-dependency HTTP routing engine and middleware architecture from scratch, providing deterministic path matching and optimized request parsing pipelines.",
      "Implemented an ultra-low latency static file streaming cache and a cryptographically sound session-authentication handling subsystem to securely process heavy backend workflows."
    ],
    github: "https://github.com/dharshithdev/Backend-Server-using-CPP.git",
    live: null,
    tag: "C++",
  },
  { 
    id: 4,
    title: "Synapse Distributed API Gateway & Core Proxy",
    subtitle: "Cloud-Native Reverse Proxy & Traffic Management Engine",
    period: "June 2026",
    stack: ["Node.js", "Express", "Redis", "MongoDB", "TLS/Network Security"],
    color: "#0284c7", // Sky blue tone to match API/Cloud architectures
    description: "High-performance distributed API gateway and core proxy built from scratch to orchestrate dynamic path routing, cross-cluster communication, and live traffic security.",
    highlights: [
      "Engineered a dynamic reverse proxy utilizing Node.js and Express to route inbound microservice traffic and verify cryptographic client API keys under 50ms.",
      "Implemented a distributed cloud rate-limiting tier using an Upstash Redis cluster over secure TLS connection layers with atomic increment tracking.",
      "Developed a defensive socket connection handler with automatic auto-heal logic to actively recover from sudden cloud firewall resets and network idle dropouts."
    ],
    github: "https://github.com/dharshithdev/Synapse-API.git", // Updated to your profile name structure
    live: "https://synapse-api-way.vercel.app",
    tag: "Node.js",
  },
{
    id: 5,
    title: "FactoryPulse Real-Time Manufacturing Platform",
    subtitle: "Real-Time Manufacturing Monitoring & Automation System",
    period: "August 2026",
    stack: ["React", "Node.js", "Express", "MongoDB", "Socket.IO", "JWT"],
    color: "#0284c7",
    description: "Production-style manufacturing monitoring platform for real-time machine telemetry, automated alerts, analytics, and factory performance management.",
    highlights: [
      "Engineered a real-time manufacturing dashboard using React and Socket.IO to monitor machine temperature, pressure, RPM, power, and production metrics.",
      "Implemented a configurable sensor simulator, automated threshold-based alert engine, historical analytics, machine lifecycle management, and CSV reporting.",
      "Developed a secure REST API with JWT authentication and Controller-Service-Repository architecture, deployed through Vercel, Render, and MongoDB Atlas."
    ],
    github: "https://github.com/dharshithdev/Factory-Pulse.git",
    live: "https://factory-pulse-way.vercel.app/",
    tag: "Enterprise",
},
  {
    id: 6,
    title: "Real-Time Object Detection",
    subtitle: "YOLOv8 Surveillance System",
    period: "July 2025",
    stack: ["Python", "YOLOv8", "OpenCV", "NumPy"],
    color: "#10b981",
    description: "High-performance real-time surveillance system with consistent 30 FPS. Deployed YOLOv8 integrated with OpenCV for high-performance monitoring.",
    highlights: ["Consistent 30 FPS via YOLOv8 + OpenCV integration", "15% precision boost through custom pre-processing & data augmentation", "Automated monitoring workflows for variable environments"],
    github: "https://github.com/dharshithdev",
    live: null,
    tag: "Computer Vision", 
  },
  {
    id: 7,
    title: "HerCare – Healthcare Platform",
    subtitle: "AI-Powered MERN Application",
    period: "April 2025",
    stack: ["MERN", "Cloudinary", "Framer Motion", "Recharts", "JWT"],
    color: "#ec4899",
    description: "Comprehensive healthcare MERN platform with 3D fetal development visualizer, e-commerce module, and real-time health dashboards.",
    highlights: ["40% increase in user engagement with 3D fetal visualizer + Cloudinary API", "100% data consistency via MongoDB Transactions + custom Express middleware", "25% faster rendering through React lazy-loading + Framer Motion"],
    github: "https://github.com/dharshithdev",
    live: "https://her-care-phi.vercel.app/",
    tag: "Healthcare",
  },
  {
    id: 8,
    title: "Healthcare Resource Planning",
    subtitle: "Enterprise MERN Backend",
    period: "July 2025",
    stack: ["MERN", "RBAC", "JWT", "MongoDB", "Express"],
    color: "#3b82f6",
    description: "Enterprise-grade healthcare backend with Role-Based Access Control, optimized for sub-200ms API latency and high availability.",
    highlights: ["30% reduction in admin processing time via RBAC + JWT auth", "20% reliability improvement through normalized NoSQL schema", "RESTful API optimized for sub-200ms latency at high availability"],
    github: "https://github.com/dharshithdev",
    live: "https://hrp-seven.vercel.app/",
    tag: "Enterprise",
  },
  {
    id: 9,
    title: "NLP Analytics Engine",
    subtitle: "Data Science Pipeline",
    period: "Dec 2025",
    stack: ["Python", "Scikit-learn", "Pandas", "TF-IDF", "Google Colab"],
    color: "#8b5cf6",
    description: "End-to-end NLP analytics engine processing 10,000+ data points with automated model evaluation pipelines.",
    highlights: ["18% boost via TF-IDF + word embeddings feature engineering", "Processed 10,000+ data points with 10% decision-making improvement", "Automated ROC-AUC and confusion matrix reporting pipeline"],
    github: "https://github.com/dharshithdev",
    live: null,
    tag: "Data Science",
  },
  {
    id: 10,
    title: "E-Commerce Platform",
    subtitle: "Full-Featured PHP / MySQL",
    period: "Dec 2025",
    stack: ["PHP", "MySQL", "Laravel", "REST API"],
    color: "#f97316",
    description: "Robust e-commerce backend in PHP handling product catalogs, user accounts, and order processing with optimized database performance.",
    highlights: ["30% speed improvement via advanced SQL query restructuring + indexing", "Complex relational logic for catalogs, accounts, and order processing", "100% data integrity across high-volume transactions"],
    github: "https://github.com/dharshithdev",
    live: null,
    tag: "E-Commerce",
  },
];

export const experience = [
  {
    role: "Software Developer",
    company: "SN Plastics",
    type: "Full-time",
    period: "Nov 2024 – Present",
    location: "Bangalore, Karnataka",
    color: "#00f5ff",
    highlights: [
      "Architected custom internal software suite (PHP/MySQL), reducing admin overhead by 20%",
      "Optimized MySQL queries improving data retrieval speeds by 30% with 100% data integrity",
      "Digitized inventory tracking resulting in 15% workflow efficiency improvement",
    ],
  },
  {
    role: "AI & ML Intern",
    company: "YBI Foundation",
    type: "Internship",
    period: "May 2025",
    location: "Remote",
    color: "#7c3aed",
    highlights: [
      "Hands-on Python for data analysis, machine learning, and AI applications",
      "Built predictive models on real-world datasets with data visualization",
      "Data preprocessing, model training, and performance evaluation",
    ],
  },
];

export const education = [
  {
    degree: "Bachelor of Computer Applications (BCA)",
    institution: "Bangalore University",
    period: "Aug 2022 – Jun 2025",
    location: "Bangalore, Karnataka",
  },
];

export const certifications = [
  {
    title: "AI & Machine Learning",
    issuer: "Netcraftz",
    period: "2022 – 2025",
    color: "#f59e0b",
    icon: "Brain",
    details: [
      "End-to-end predictive pipelines using Scikit-learn",
      "EDA with Pandas & NumPy, Matplotlib & Seaborn visualization",
      "Model evaluation: F1-score, Precision-Recall, Confusion Matrices",
    ],
  },
  {
    title: "Cybersecurity / Ethical Hacking",
    issuer: "Netcraftz",
    period: "2022 – 2025",
    color: "#10b981",
    icon: "Shield",
    details: [
      "Vulnerability assessments and ethical hacking scenarios",
      "Threat detection protocols and secure authentication practices",
      "System hardening for data privacy and regulatory compliance",
    ],
  },
    {
    title: "AI ML with Data Science",
    issuer: "YBI Foundation",
    period: "2025",
    color: "#1310b9",
    icon: "Database",
    details: [
      "Data preprocessing, model training, and performance evaluation",
      "Threat detection protocols and secure authentication practices",
      "Hands-on Python for data analysis, machine learning, and AI applications",
    ],
  }
];
